// src/pages/Legal/PrivacyPage.js
import React from 'react';
import { Container, Typography, Paper, Box, Divider, List, ListItem, ListItemText } from '@mui/material';

const RENGIGS = {
  green: '#2E7D32',
  lightGreen: '#4CAF50',
  lime: '#CDDC39',
  dark: '#1A2A3A',
  light: '#F8FAFC',
  border: '#E1E9F0',
  gradient: 'linear-gradient(135deg, #2E7D32 0%, #4CAF50 40%, #8BC34A 70%, #CDDC39 100%)',
};

const PrivacyPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: `1px solid ${RENGIGS.border}` }}>
        <Typography variant="h3" sx={{ fontWeight: 900, color: RENGIGS.dark, mb: 1 }}>
          Privacy Policy
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
          Effective date: April 19, 2026
        </Typography>
        <Divider sx={{ mb: 4 }} />

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>1. Information We Collect</Typography>
        <Typography variant="body1" paragraph>
          We collect information you provide directly to us, such as when you create an account, post a problem, list a solution, or communicate with other users. This may include your name, email address, phone number, company name, and payment information.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>2. How We Use Your Information</Typography>
        <Typography variant="body1" paragraph>
          We use the information to operate, maintain, and improve our platform, to communicate with you, to process transactions, and to personalize your experience.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>3. Sharing of Information</Typography>
        <Typography variant="body1" paragraph>
          We do not sell your personal information. We may share your information with service providers (e.g., Stripe for payments), as required by law, or with your consent.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>4. Data Security</Typography>
        <Typography variant="body1" paragraph>
          We implement reasonable security measures to protect your information. However, no transmission over the Internet is 100% secure.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>5. Your Rights</Typography>
        <Typography variant="body1" paragraph>
          You may access, update, or delete your account information. Depending on your location, you may have additional rights under applicable data protection laws.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 800, color: RENGIGS.green, mb: 2 }}>6. Changes to This Policy</Typography>
        <Typography variant="body1" paragraph>
          We may update this Privacy Policy from time to time. We will notify you of any material changes.
        </Typography>

        <Typography variant="body2" sx={{ mt: 4, color: 'text.secondary' }}>
          For questions, contact us at privacy@rengigs.com.
        </Typography>
      </Paper>
    </Container>
  );
};

export default PrivacyPage;